import {
  Box,
  Button,
  Grid,
  Radio,
  RadioGroup,
  FormControlLabel,
  Typography,
} from "@mui/material";
import { useState } from "react";
import { useActividadesContext } from "../../UmmIACategories/Hook/useActividades";

const defaultOptions = [
  "Mini Teatro de Lectura",
  "Desafío Rápido y Correcto",
  "Lectura en Eco + Lectura en Coro",
  "Caza de errores",
  "La Búsqueda Lectora",
  "Radio familiar",
];

const optionToWrapperMap: Record<string, string> = {
  "Mini Teatro de Lectura": "mini_teatro_lectura",
  "Desafío Rápido y Correcto": "desafio_rapido",
  "Lectura en Eco + Lectura en Coro": "lectura_eco_y_coro",
  "Caza de errores": "caza_errores",
  "La Búsqueda Lectora": "busqueda_lectores",
  "Radio familiar": "radio_familiar",
};

export default function JuegosCasa() {
  const { setPromptData } = useActividadesContext();
  const [selectedOption, setSelectedOption] = useState<string>("");

  const handleSelectOption = (value: string) => {
    setSelectedOption(value);

    const envoltorio = optionToWrapperMap[value] || "radio_juegos";

    setPromptData((prev: any) => ({
      ...prev,
      ganador: value,
      envoltorio,
    }));
  };

  const handleConfirm = () => {
    if (selectedOption) {
      alert(`Has seleccionado: ${selectedOption}`);
    }
  };

  return (
    <Grid
      container
      spacing={2}
      alignItems="center"
      justifyContent="center"
      flexWrap="wrap"
      mt={5}
    >
      {/* Título y texto */}
      <Grid item xs={12} md={6}>
        <Box textAlign={{ xs: "center" }}>
          <Typography
            variant="h4"
            fontWeight="bold"
            color="#336B87"
            fontSize={54}
            gutterBottom
          >
            Selección de juegos
          </Typography>
          <Typography color="text.secondary" mb={2}>
            <strong>Elige una actividad para continuar</strong>
          </Typography>
          <Typography color="text.secondary" mb={4}>
            Marca la opción que prefieras. Al confirmar, se actualizará tu
            actividad seleccionada en la aplicación.
          </Typography>

          {/* Resultado */}
          {selectedOption && (
            <Box
              bgcolor="#278C62"
              px={4}
              py={2}
              borderRadius={3}
              boxShadow={3}
              textAlign="center"
              mb={3}
            >
              <Typography variant="h6" fontWeight="bold" color="white">
                Selección actual:
              </Typography>
              <Typography color="white">{selectedOption}</Typography>
            </Box>
          )}

          
        </Box>
      </Grid>

      {/* Opciones con radio buttons */}
      <Grid item xs={12} md={6}>
        <Box
          sx={{
            border: "2px solid #336B87",
            borderRadius: 3,
            padding: 3,
            boxShadow: 2,
          }}
        >
          <RadioGroup
            name="juegos"
            value={selectedOption}
            onChange={(e) => handleSelectOption(e.target.value)}
          >
            {defaultOptions.map((option, index) => (
              <FormControlLabel
                key={index}
                value={option}
                control={<Radio sx={{ color: "#336B87" }} />}
                label={option}
              />
            ))}
          </RadioGroup>
        </Box>
      </Grid>
    </Grid>
  );
}
